"use client";
import React, { useEffect, useRef, useState } from "react";
import { FilePlus2, Plus } from "lucide-react";
import { useUser } from "@/app/context/UserContext";
import { iProProjectMain } from "@/app/models/interfaceProject";
import { chatbotMyDocs } from "@/app/services/chatbotmydocs";
import { Action, TypeLayout } from "@/app/constants/enums";
import SourcesList from "./SourcesList";
import MySourcesList, { MySourcesListRef } from "./MySourcesList";
import Accordion from "../../Elements/Accordion";
import ButtonChat from "../../Elements/Core/ButtonChat";
import InputChat from "../../Elements/Core/InputChat";
import ConversationManager, { ConversationManagerRef } from "../../Conversation/ConversationManager";

 


const SourceView = () => {
  const {
    user,
    setUser,
    userLoading,
    userLoaded,
    userProject,
    setUserProject,
    typeLayout,
    myDocs,
    setMyDocs,
    myDocsLoading,
    setMyDocsLoading,
  } = useUser();

  // const [openAccordion, setOpenAccordion] = useState<boolean[]>([true, true]);
    const [openAccordion, setOpenAccordion] = useState<boolean[]>([true, true, true]);   
    const mySourcesRef = useRef<MySourcesListRef>(null);
    const convManagerRef = useRef<ConversationManagerRef>(null);


   const toggleAccordion = (index: number) => {
        setOpenAccordion((prev) =>
            prev.map((open, i) => (i === index ? !open : open))
        );
    };

  const fetchDataMyDoc = async () => {
    setMyDocsLoading(true);
    if (userLoaded && user && !user.isAnonymous) {
      try {
        const response = await chatbotMyDocs(user, setUser);
        if (response.success && response.code === 200) {
          setMyDocs(response.data);
        } else {
          setMyDocs(null);
        }
      } catch {
        setMyDocs(null);
      } finally {
        setMyDocsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (user && typeLayout === TypeLayout.Personal) {
      fetchDataMyDoc();
    }
  }, [user?.email, userLoaded]);

  const handleSelectDocs = (checked: boolean) => {
    setUserProject((prev: iProProjectMain) => ({
      ...prev,
      useDocs: checked,
      useMyDocs: !checked,
    }));
  };

  const handleSelectMyDocs = (checked: boolean) => {
    setUserProject((prev: iProProjectMain) => ({
      ...prev,
      useMyDocs: checked,
      useDocs: !checked,
    }));
  };

  return (
    <div className="w-full h-full ml-1"> 
      <Accordion
        title="Fuente"
        index={0}
        isOpen={openAccordion[0]}
        onClick={toggleAccordion}
        classNameHead="border-b border-gray-300 py-1"
        classNameBody="p-1"
        rightComponent={typeLayout === TypeLayout.Personal && (
            <InputChat
                actionCode={Action.LEFT_FUENTE}
                type="checkbox"
                checked={userProject?.useDocs ?? false}
                onChange={(e) => handleSelectDocs(e.target.checked)}
                className="h-5 w-5 text-blue-600 rounded flex-shrink-0 focus:outline-none focus:ring-1 focus:ring-blue-700"
            />
            )}
        
        viewChevron={false}
      >
        <SourcesList
          userLoading={userLoading}
          userProject={userProject}
          typeLayout={typeLayout}
        />
      </Accordion>

      {(typeLayout === TypeLayout.Personal || !user.isAnonymous) && (
        <Accordion
          title="Mis Fuentes"
          index={1}
          isOpen={openAccordion[1]}
          onClick={toggleAccordion}
          classNameHead="border-b py-1"
          classNameBody="p-1"
          rightComponent={
            <div className="flex items-center">
                <InputChat
                actionCode={Action.LEFT_MY_DOC}
                type="checkbox"
                checked={userProject?.useMyDocs ?? false}
                onChange={(e) => handleSelectMyDocs(e.target.checked)}
                className="h-5 w-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-300 flex-shrink-0 ml-5"
                />
                <ButtonChat
                actionCode={Action.LEFT_MY_DOC_ADD}
                type="button"
                onClick={() => mySourcesRef.current?.handleAdd()} // mertodo el componente hijo  MySourcesList
                className="ml-3 rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out flex-shrink-0 -m-2"
                >
                    <FilePlus2 strokeWidth={1} className="m-2" />
                </ButtonChat>
            </div>
          }
          viewChevron={false}
        >
          <MySourcesList
            handleSelectMyDocs={handleSelectMyDocs}
            ref={mySourcesRef}
          />
        </Accordion>
      )} 
      {/*
        <Accordion
          title="Conversaciones"
          index={2}
          isOpen={openAccordion[2]}
          onClick={toggleAccordion}
          classNameHead="border-b py-1"
          classNameBody="p-1"
          rightComponent={
            <div className="flex items-center">
              <ButtonChat
                actionCode={Action.LEFT_CONVERSATION_ADD}
                type="button"
                onClick={() => convManagerRef.current?.handleAdd()}  
                className="ml-3 rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out flex-shrink-0 -m-3"
              >
                <Plus strokeWidth={1} className="m-2" />
              </ButtonChat>
            </div>
          }
          viewChevron={false}
        >
          <ConversationManager ref={convManagerRef} />
        </Accordion>
      */}
     

     
    </div>
  );
};

export default SourceView;
